
import { Component, Vue, Watch } from 'vue-property-decorator'

import { Game } from '../../lib/models/Game'

@Component({})
export default class ChatChallengesComponent extends Vue {
  games: Game[] = []

  mounted () {
    this.loadGames()
  }

  @Watch('$store.state.PageURLRallyRound.rallyRound')
  async loadGames () {
    if (!this.$store.state.PageURLRallyRound.rallyRound.id) {
      return // rally round not loaded yet
    }
    this.games = await Game.getForRallyRound(this.$store.state.PageURLRallyRound.rallyRound.id)
  }
}
